import './styles.editor.scss';
import { registerBlockType } from '@wordpress/blocks';
import ServerSideRender from '@wordpress/server-side-render';
import { __ } from '@wordpress/i18n';
import { Component, useState, useEffect, Fragment } from '@wordpress/element';
import IconWishListMember from '../icons/icon-wishlist-member';
import {
	Toolbar,
	ToolbarGroup,
	ToolbarItem,
	DropdownMenu,
	PanelBody,
	ToggleControl,
	Button,
	Disabled,
} from '@wordpress/components';
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import Loading from '../loading';

registerBlockType('wishlist-box-basic-blocks/profileform', {
	title: __('Profile Form', 'wishlist-member'),
	description: __('Display Profile Form', 'wishlist-member'),
	category: 'wishlist-box-basic-blocks-category',
	keywords: [__('wlm'), __('member'), __('access')],
	icon: IconWishListMember,
	attributes: {
		content: {
			type: 'string',
			default: '',
		},
		listsubscription: {
			type: 'boolean',
			default: true,
		},
		profile_photo: {
			type: 'boolean',
			default: true,
		},
		first_name: {
			type: 'boolean',
			default: true,
		},
		last_name: {
			type: 'boolean',
			default: true,
		},
		nickname: {
			type: 'boolean',
			default: true,
		},
		display_name: {
			type: 'boolean',
			default: true,
		},
		email: {
			type: 'boolean',
			default: true,
		},
		user_password: {
			type: 'boolean',
			default: true,
		},
		company: {
			type: 'boolean',
			default: true,
		},
		address1: {
			type: 'boolean',
			default: true,
		},
		address2: {
			type: 'boolean',
			default: true,
		},
		city: {
			type: 'boolean',
			default: true,
		},
		state: {
			type: 'boolean',
			default: true,
		},
		zip: {
			type: 'boolean',
			default: true,
		},
		country: {
			type: 'boolean',
			default: true,
		}
	},
	edit(props) {
		const { attributes, setAttributes } = props;
		const blockProps = useBlockProps();

		const content = attributes.content;
		const listsubscription = attributes.listsubscription;
		const profile_photo = attributes.profile_photo;
		const first_name = attributes.first_name;
		const last_name = attributes.last_name;
		const nickname = attributes.nickname;
		const display_name = attributes.display_name;
		const email = attributes.email;
		const user_password = attributes.user_password;
		const company = attributes.company;
		const address1 = attributes.address1;
		const address2 = attributes.address2;
		const city = attributes.city;
		const state = attributes.state;
		const zip = attributes.zip;
		const country = attributes.country;

		const onChangelistsubscription = (value) => {
			setAttributes({ listsubscription: value });
		};

		useEffect(() => {}, [listsubscription, profile_photo, content]);

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody title={__('Options', 'wishlist-member')}>
						<p>Select fields to display</p>
						<ToggleControl
							label={__('Profile Photo', 'wishlist-member')}
							checked={profile_photo}
							onChange={(profile_photo) => {
								setAttributes({ profile_photo });
							}}
						/>
						<ToggleControl
							label={__('First Name', 'wishlist-member')}
							checked={first_name}
							onChange={(first_name) => {
								setAttributes({ first_name });
							}}
						/>
						<ToggleControl
							label={__('Last Name', 'wishlist-member')}
							checked={last_name}
							onChange={(last_name) => {
								setAttributes({ last_name });
							}}
						/>
						<ToggleControl
							label={__('Nickname', 'wishlist-member')}
							checked={nickname}
							onChange={(nickname) => {
								setAttributes({ nickname });
							}}
						/>
						<ToggleControl
							label={__('Display Name', 'wishlist-member')}
							checked={display_name}
							onChange={(display_name) => {
								setAttributes({ display_name });
							}}
						/>
						<ToggleControl
							label={__('Email', 'wishlist-member')}
							checked={email}
							onChange={(email) => {
								setAttributes({ email });
							}}
						/>
						<PanelBody title={__('Address', 'wishlist-member')}>
							<ToggleControl
								label={__('Company', 'wishlist-member')}
								checked={company}
								onChange={(company) => {
									setAttributes({ company });
								}}
							/>
							<ToggleControl
								label={__('Address (First Line)', 'wishlist-member')}
								checked={address1}
								onChange={(address1) => {
									setAttributes({ address1 });
								}}
							/>
							<ToggleControl
								label={__('Address (Second Line)', 'wishlist-member')}
								checked={address2}
								onChange={(address2) => {
									setAttributes({ address2 });
								}}
							/>
							<ToggleControl
								label={__('City', 'wishlist-member')}
								checked={ city}
								onChange={( city) => {
									setAttributes({ city });
								}}
							/>
							<ToggleControl
								label={__('State', 'wishlist-member')}
								checked={state}
								onChange={(state) => {
									setAttributes({ state });
								}}
							/>
							<ToggleControl
								label={__('Zip', 'wishlist-member')}
								checked={zip}
								onChange={(zip) => {
									setAttributes({ zip });
								}}
							/>
							<ToggleControl
								label={__('Country', 'wishlist-member')}
								checked={country}
								onChange={(country) => {
									setAttributes({ country });
								}}
							/>
						</PanelBody>
						<ToggleControl
							label={__(
								'Mailing List Subscription',
								'wishlist-member'
							)}
							checked={listsubscription}
							onChange={(listsubscription) => {
								onChangelistsubscription(listsubscription);
							}}
						/>
						<ToggleControl
							label={__('New Password', 'wishlist-member')}
							checked={user_password}
							onChange={(user_password) => {
								setAttributes({ user_password });
							}}
						/>
					</PanelBody>
				</InspectorControls>
				<div {...blockProps}>
					<Disabled>
						<ServerSideRender
							block="wishlist-box-basic-blocks/profileform"
							attributes={attributes}
							httpMethod="POST"
							LoadingResponsePlaceholder={Loading}
							// attributes={ {
							// 	optionSort: attributes.optionSort
							// } }
						/>
					</Disabled>
				</div>
			</Fragment>
		);
	},
	save(props) {
		return null;
	},
});
